import { styled } from "@pigment-css/react";
import { CrossLarge } from "@acto/web-common/components";
import { useTranslations } from "@acto/web-common/locales";
import { OutlinedPillButton } from "@acto/taskpane/field-sales-2/components/primitives/OutlinedPillButton";
import { SolidCtaButton } from "@acto/taskpane/field-sales-2/components/primitives/SheetCta";
import { BOTTOM_NAV_TAB_ROW_HEIGHT } from "@acto/taskpane/field-sales-2/components/patterns/BottomNav";

const Bar = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.fieldSalesTwo.spacing[12],
  width: "100%",
  minHeight: theme.fieldSalesTwo.spacing[BOTTOM_NAV_TAB_ROW_HEIGHT],
}));

const ClearButton = styled(OutlinedPillButton)(({ theme }) => ({
  flexShrink: 0,
  width: theme.fieldSalesTwo.spacing[50],
  padding: 0,
  background: theme.fieldSalesTwo.colors.surface.glass,
  "& svg": { width: "16px", height: "16px" },
}));

interface SelectionActionBarProps {
  count: number;
  onClear: () => void;
  onContinue: () => void;
  disabled?: boolean;
}

export function SelectionActionBar({ count, onClear, onContinue, disabled }: SelectionActionBarProps) {
  const t = useTranslations("fieldSalesTwo.genuiMeetingPrep.productHide");

  return (
    <Bar>
      <ClearButton type="button" onClick={onClear} aria-label={t("clearSelection")}>
        <CrossLarge aria-hidden="true" />
      </ClearButton>
      <SolidCtaButton type="button" onClick={onContinue} disabled={disabled}>
        {t("hideSelected", { count })}
      </SolidCtaButton>
    </Bar>
  );
}
